import { render, staticRenderFns } from "./DateEditor.vue?vue&type=template&id=2bb984dc&scoped=true&"
import script from "./DateEditor.vue?vue&type=script&lang=ts&"
export * from "./DateEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DateEditor.vue?vue&type=style&index=0&id=2bb984dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb984dc",
  null
  
)

export default component.exports